import {
  Divider,
  Row,
  Space,
  Spin,
  Switch,
  Typography,
  Popconfirm,
  Tabs
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  getTrainer,
  getTrainerPublicProfileInfo,
  updateTrainerInfo,
  updateTrainerPublicProfileInfo
} from '../../services/trainerServices';
import TabsView from '../Common/TabsVIew';
import BasicInfo from './BasicInfo/BasicInfo';
import Creations from './Creations/Creations';
import Interests from './Interests/Interests';
import Milestones from './Milestones/Milestones';
import SocialMedia from './SocialMedia';
import './Trainer.css';

const { Text, Title } = Typography;
const { TabPane } = Tabs;

const TrainerInfo = () => {
  const { id } = useParams();
  const [trainer, setTrainer] = useState({});
  const [status, setStatus] = useState({
    type: 'LOADING',
    message: 'Loading data!'
  });
  const [showPublicProfile, setShowPublicProfile] = useState(true);
  const [loadPublicProfile, setLoadPublicProfile] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setStatus({ type: 'LOADING', message: 'Loading data!' });
    getTrainer({ trainerId: id })
      .then((response) => {
        if (response.data?.trainer) {
          const trainerFullData = response.data.trainer;
          setTrainer(trainerFullData);
          fetchTrainerPublicProfile(trainerFullData._id);
        } else throw new Error();
        setStatus({
          type: 'SUCCESS',
          message: 'Data successfully received!'
        });
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const fetchTrainerPublicProfile = (id) => {
    getTrainerPublicProfileInfo({ trainerObjectId: id })
      .then((response) => {
        if (response.data?.trainerPublicProfile)
          setShowPublicProfile(
            response.data.trainerPublicProfile.isPublic
          );
        else throw new Error();
      })
      .catch((error) => {
        console.log(
          'Error getting trainer public profile data from the admin backend:',
          error
        );
        alert(
          'Getting trainer public profile data from the backend failed!'
        );
      });
  };

  const updateTrainerLocalData = (data) => {
    setTrainer(data);
  };

  const updateTrainerData = (value) => {
    return updateTrainerInfo(id, value);
  };

  const changeShowPublicProfile = async () => {
    const newStatus = !showPublicProfile;
    await updateTrainerPublicProfileInfo(trainer._id, {
      isPublic: newStatus
    })
      .then((response) => {
        setLoadPublicProfile(true);
        setShowPublicProfile(newStatus);
        setStatus({
          type: 'SUCCESS',
          message: 'Data updated successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const tabs = [
    {
      render: () => (
        <BasicInfo
          basicInfo={trainer}
          updateTrainerLocalData={updateTrainerLocalData}
        />
      ),
      tab: 'Basic Info'
    },
    {
      render: () => (
        <SocialMedia
          trainer={trainer}
          updateTrainerLocalData={updateTrainerLocalData}
        />
      ),
      tab: 'Social Media'
    },
    {
      render: () => (
        <Creations
          trainer={trainer}
          updateTrainerLocalData={updateTrainerLocalData}
          updateTrainerData={updateTrainerData}
        />
      ),
      tab: 'Creations'
    },
    {
      render: () => (
        <Interests
          trainer={trainer}
          updateTrainerLocalData={updateTrainerLocalData}
          updateTrainerData={updateTrainerData}
        />
      ),
      tab: 'Interests'
    },
    {
      render: () => (
        <Milestones
          trainer={trainer}
          updateTrainerLocalData={updateTrainerLocalData}
          updateTrainerData={updateTrainerData}
        />
      ),
      tab: 'Milestones'
    }
  ];

  if (status.type === 'LOADING') return <Spin size="large" />;

  if (status.type === 'ERROR')
    return (
      <Text type="danger">
        Something went wrong, Try Again or Contact Admin.
      </Text>
    );

  return (
    <div>
      <Row justify="space-between">
        <Title level={3}>
          Trainer {`${trainer.firstName} ${trainer.lastName}`}
        </Title>
        {trainer && loadPublicProfile ? (
          <div className="toggle-title-wrapper">
            <span>Show in trainers list?</span>
            <Popconfirm
              placement="top"
              title="Are you sure you want to change status?"
              onConfirm={changeShowPublicProfile}
              okText="Yes"
              cancelText="No">
              <Switch checked={showPublicProfile} />
            </Popconfirm>
          </div>
        ) : null}
      </Row>
      <TabsView data={tabs} />
    </div>
  );
};

export default TrainerInfo;
